import "./Services.module.css";
import SiteNavigation from "@/reusable_sections/Header";
import Gallery from "./sections/Gallery";
import Hero from "./sections/Hero";
import OurValues from "./sections/OurValues";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <SiteNavigation />
      <Gallery />
      <Hero />
      <OurValues />
      <GetInTouch />
      <Footer />
    </div>;
}